import App from '../views/App.vue'
import { createApp } from 'vue'
const app = createApp(App)

export default app